module.exports = __webpack_public_path__ + "img/Crown _ Anchor.bda87244.jpg";